import React, {useContext, useEffect} from "react";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

import "../scss/common.scss";
import "../scss/component.scss";
import { Footer, Header } from "./layout";
import { HeadBlock } from "./layout/HeadBlock";
import {PlanSelectFormData} from "../types/planSelectForm";
import {useLocation} from "react-router-dom";
import {defaultFooter, defaultFooterPages, siteTitle} from "../config/main";
import {TagManagerContext, TagManagerType} from "../hooks/GTM";
import i18n from "i18next";

//パレットカラー変更
const theme = createTheme({
  palette: {
    secondary: {
      light: "#3387df",
      main: "#0169D8",
      dark: "#004997",
      contrastText: "#fff",
    },
  },
});



export interface Props {
  children: React.ReactNode;
  title: string;
  planSelectFormData: PlanSelectFormData | undefined
  fixedBottom?:boolean; //下部に固定ナビがある場合はtrue
  /**
   * `<main>` に足すクラス（任意）。 issue #2992
   * ★既定は付けない＝**通常のページの見た目は変わらない**。
   *   入場制御（待合室）だけ `.l-main--waiting-room`（縦中央寄せ・下 80px の余白を消す）を渡している。
   */
  mainClass?: string;
}

const MainTemplate: React.FC<Props> = ({
    planSelectFormData,
    children,
    title,
    fixedBottom,
    mainClass
}) => {
    const tagManagerContext: TagManagerType = useContext(TagManagerContext);
    const simpleNavi = useLocation().pathname;
    const header = {
        logo: planSelectFormData?.logo
    }
    const footer = {
        sellerId: 0,
        supportDial: '',
        businessHours: '',
        footerText: ''
    }

    //共通ページでのフッター情報設定
    if (defaultFooterPages.includes(simpleNavi)) {
        footer.sellerId = defaultFooter.sellerId;
        footer.supportDial = defaultFooter.supportDial;
        footer.businessHours = defaultFooter.businessHours;
        footer.footerText = defaultFooter.footerText;
    }
  
    // 言語別 footerTitle設定
    const getFooterText = () => {
      if (i18n.language === 'en') {
        return planSelectFormData?.planData?.product?.footerTextEn ?? defaultFooter.footerText;
      }
      return planSelectFormData?.planData?.product?.footerText ?? defaultFooter.footerText;
    }

    // 言語別 businessHours設定
    const getBusinessHours = () => {
      if (i18n.language === 'en') {
        return planSelectFormData?.planData?.product?.businessHoursEn || defaultFooter.businessHours;
      }
      return planSelectFormData?.planData?.product?.businessHours || defaultFooter.businessHours;
    }

    if (planSelectFormData) {
        footer.sellerId = planSelectFormData?.planData?.sellerIndo.sellerId?? 0;
        if (planSelectFormData?.planData?.product?.supportDial) {
            footer.supportDial = planSelectFormData?.planData?.product.supportDial;
        } else if (planSelectFormData?.planData?.sellerIndo.supportDial) {
            footer.supportDial = planSelectFormData?.planData?.sellerIndo.supportDial
        }
      
      footer.businessHours = getBusinessHours();
      
      footer.footerText = getFooterText();
    }
    
    // useEffect(() => {
    //   if (title !== siteTitle) {
    //     tagManagerContext.pageView(title);
    //   }
    // }, [title])
  return (
    <>
      <ThemeProvider theme={theme}>
        <HeadBlock title={title} />
  
        <div className="theme-wrap">
          <Header logo={header.logo}/>
          <main className={mainClass}>
              <div className="l-page-content">
                {children}
              </div>
          </main>
          <div className={(fixedBottom? "pb-100":"")}>
            <Footer
            sellerId={footer.sellerId}
            supportDial={footer.supportDial}
            businessHours={footer.businessHours}
            footerText={footer.footerText}
            />
          </div>
        </div>
      </ThemeProvider>
    </>
  );
};

export default MainTemplate;
